import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgList = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 16V14H3V16H5ZM5 12V10H3V12H5ZM5 8V6H3V8H5ZM19 16V14H7V16H19ZM19 12V10H7V12H19ZM19 8V6H7V8H19Z"
      fill="currentColor"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgList);

export default ForwardRef;
